import { LuCalendarPlus } from 'react-icons/lu';
// Apple Calendar is switched off for now — see the note in the component.
// import { LuChevronDown } from 'react-icons/lu';
// import {
//   DropdownMenu,
//   DropdownMenuContent,
//   DropdownMenuItem,
//   DropdownMenuTrigger,
// } from '@mds/shared/ui/shadcn/dropdown-menu';

import { Button } from '@mds/shared/ui/shadcn/button';

import { googleCalendarUrl, type CalendarEvent } from '@/lib/calendar';
// import { downloadAppleCalendarFile } from '@/lib/calendar';

/**
 * "Add to Google Calendar": a plain link that opens Google Calendar in a new
 * tab with the event already filled in — the visitor only presses Save.
 *
 * Apple Calendar is off for now. It has no link format, only an `.ics` file,
 * and a file built in the browser is often saved to Files on an iPhone instead
 * of opening Calendar. The menu that offered both is kept below, commented
 * out; it comes back once the backend serves the event as an `.ics` from a
 * real address, which iOS opens straight in Calendar.
 */
export default function AddToCalendar({
  event,
  variant = 'default',
}: {
  event: CalendarEvent;
  variant?: 'default' | 'outline';
}) {
  return (
    <Button asChild size="lg" variant={variant}>
      <a href={googleCalendarUrl(event)} target="_blank" rel="noopener noreferrer">
        <LuCalendarPlus aria-hidden="true" />
        Add to Google Calendar
      </a>
    </Button>
  );

  // Google and Apple, as a menu:
  //
  // return (
  //   <DropdownMenu>
  //     <DropdownMenuTrigger asChild>
  //       <Button size="lg" variant={variant}>
  //         <LuCalendarPlus aria-hidden="true" />
  //         Add to calendar
  //         <LuChevronDown aria-hidden="true" />
  //       </Button>
  //     </DropdownMenuTrigger>
  //     <DropdownMenuContent align="center">
  //       <DropdownMenuItem asChild>
  //         <a href={googleCalendarUrl(event)} target="_blank" rel="noopener noreferrer">
  //           Google Calendar
  //         </a>
  //       </DropdownMenuItem>
  //       <DropdownMenuItem onSelect={() => downloadAppleCalendarFile(event)}>
  //         Apple Calendar
  //       </DropdownMenuItem>
  //     </DropdownMenuContent>
  //   </DropdownMenu>
  // );
}
